const initialState = {
    education: {
        name: '',
    },
    listEducation: [],
    spinner: true,
}

export default (state = initialState, action) => {
    switch (action.type) {
        case 'HANDLE_INPUT_CHANGE_EDUCATION':
            return Object.assign({}, state, {
                education: {
                    ...state.education,
                    [action.name]: action.value
                }
            })

        case "VIEW_EDUCATION":
            return Object.assign({}, state, {
                education: action.payload,
                spinner: action.spinner
            });

        case 'LIST_EDUCATION':
            return {
                ...state,
                listEducation: action.payload,
                spinner: action.spinner
            }

        case 'EMPTY_EDUCATION':
            return Object.assign({}, state, {
                education: {
                    name: '',
                },
                spinner: false
            })

        default:
            return state;
    }
}